<script>
  export let input;
  function addDashes() {
    let isNumber = /^\d+$/.test(input);
    if (!isNumber) {
      return input;
    }
    let i = input.replace(/\D[^\.]/g, "");
    return i.slice(0, 3) + "-" + i.slice(3, 6) + "-" + i.slice(6);
  }
  $: formatted = addDashes();

</script>

{formatted}
